"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkoutProductVariants = exports.userCheckoutTokenList = exports.checkoutDetails = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var checkout_1 = require("../fragments/checkout");

exports.checkoutDetails = graphql_tag_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  query CheckoutDetails($token: UUID!) {\n    checkout(token: $token) {\n      ...Checkout\n    }\n  }\n"])), checkout_1.checkoutFragment);
exports.userCheckoutTokenList = graphql_tag_1.default(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query UserCheckoutTokenList($channel: String) {\n    me {\n      id\n      checkoutTokens(channel: $channel)\n    }\n  }\n"])));
exports.checkoutProductVariants = graphql_tag_1.default(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  query CheckoutProductVariants($ids: [ID], $channel: String) {\n    productVariants(ids: $ids, first: 100, channel: $channel) {\n      edges {\n        node {\n          ...ProductVariant\n        }\n      }\n    }\n  }\n"])), checkout_1.checkoutProductVariantFragment);